import(/* webpackMode: "eager" */ "/Users/jerrod.a/Documents/Haulbase.ai/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BookDemoLink"] */ "/Users/jerrod.a/Documents/Haulbase.ai/src/components/marketing/BookDemoLink.tsx");
